import { schema } from 'normalizr';
import { XmlEntities } from 'html-entities';

const plugin = new schema.Entity(
  'plugins',
  {},
  {
    processStrategy(value, _parent, _key) {
      return {
        ...value,
        data: XmlEntities.decode(value.data),
      };
    },
    idAttribute: plugin => plugin.name || plugin.itemId,
  }
);

export default plugin;
